package com.vizio.redwolf.pay.model

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import kotlin.js.JsExport

@Serializable
@JsExport
data class SerialNumberResponse(
    val serialNumber: String,
    val model: String,
    val modelGroup: String,
    val modelYear: Int,
    val name: String,
    val externalId: String,
    val images: List<Image>
)

@Serializable
@JsExport
data class Image(
    val tag: String,
    val url: String
)

@Serializable
@JsExport
data class CustomerSupportErrorResponse(
    val type: String = "UNKNOWN_TYPE",
    val title: String = "UNKNOWN_TITLE",
    val status: Int = -1,
    val detail: String? = null,
    val traceId: String? = null,
)

@Serializable
@JsExport
data class Asset(
    val title: String,
    val url: String,
    val assetType: String,
    val component: String,
    val language: String,
    val year: String,
    val order: Int
)

@Serializable
@JsExport
data class SupportHoursResponse(
    val smsNumber: String,
    val phoneNumberEnglish: String,
    val phoneNumberSpanish: String,
    val phoneWeekdayBegin: String,
    val phoneWeekdayEnd: String,
    val phoneWeekendBegin: String,
    val phoneWeekendEnd: String,
    val chatWeekdayBegin: String,
    val chatWeekdayEnd: String,
    val chatWeekendBegin: String,
    val chatWeekendEnd: String,
    val timeZone: String,
    val waitTimeMessage: String
)

@Serializable
@JsExport
data class FirmwareVersionResponse(
    val firmwareVersion: String,
    val pushingFirmwareVersion: String,
    val scplVersion: String,
    val smartCastVersion: String,
    val firmwareUrl: String
)

@Serializable
@JsExport
data class CreateSupportCaseResponse(
    val caseNumber: String,
    val phoneNumber: String,
    val statusMessage: String
)
